import React from 'react'; 
import { Link } from 'react-router-dom';
import axios from 'axios'; 


class AdminUsers extends React.Component {
    constructor(props){
        super(props) 

        this.state = {
            users: [],
        }
    }

    componentDidMount() {
        if (this.props.userdata.isLoggedIn){
            const headers = {
                'X-Access-Token': this.props.userdata.accessToken
            }

            axios.get(this.props.apiurl + '/api/users/all', {headers: headers}).then(res => {
                res.data.users.forEach(function(user){
                    if (user.roles.length === 0 || user.roles.length === 1){
                        user.role = 'user'; 
                    }

                    if (user.roles.length === 2){
                        user.role = 'admin'; 
                    }
                })
                this.setState({
                    users: res.data.users
                })
            }).catch(err => {
                console.log(err); 
            })
        }
    }

    getAllUsers = () => {
        if (this.props.userdata.isLoggedIn){
            const headers = {
                'X-Access-Token': this.props.userdata.accessToken
            }

            axios.get(this.props.apiurl + '/api/users/all', {headers: headers}).then(res => {
                res.data.users.forEach(function(user){
                    if (user.roles.length === 0 || user.roles.length === 1){
                        user.role = 'user'; 
                    }

                    if (user.roles.length === 2){
                        user.role = 'admin'; 
                    }
                })
                this.setState({
                    users: res.data.users
                })
            }).catch(err => {
                console.log(err); 
            })
        }
    }

    addUser = () => {
        console.log("adding user"); 
    }

    changeStatus = (user, callback) => {
        let status = ''; 
        let roles = []; 

        if (user.status === null){
            status = 'active';
        }

        if (user.status === 'active'){
            status = 'inactive';
        }

        if (user.status === 'inactive'){
            status = 'active';
        }

        user.roles.forEach(function(obj){
            roles.push(obj.name); 
        });

        const headers = {
            'X-Access-Token': this.props.userdata.accessToken
        }

        axios.post(this.props.apiurl + '/api/user/update', {
            id: user.id,
			username: user.username,
            email: user.email,
            status: status,
            roles: roles
		},{headers: headers}).then(res => {
			if (res.status === 200) {
                callback(); 
			}
		});
    }

    
    changeRole = (user, callback) => {
        let roles = []; 

        if (user.roles.length === 1){
            roles = ['user', 'admin'];
        }

        if (user.roles.length === 2){
            roles = ['user']; 
        }

        if (user.roles.length === 3){
            roles = ['user', 'admin']; 
        }

        const headers = {
            'X-Access-Token': this.props.userdata.accessToken
        }

        axios.post(this.props.apiurl + '/api/user/update', {
            id: user.id,
			username: user.username,
            emai: user.email,
            status: user.status,
            roles: roles
		},{headers: headers}).then(res => {
			if (res.status === 200) {
                callback(); 
			}
		});

    }
    
    deleteUser = (user) => {
        console.log(user); 
    }

    render() {
        let users = []; 

       

        this.state.users.map((user, index) => {
            const processRoles = (user) => {
                let roles = []; 

                user.roles.forEach(function(obj){
                    roles.push(<li>{obj.name}</li>)
                });
               
                return roles;
            }

            users.push(
                <tr key={ index }>
                    <th>{ user.username }</th>
                    <th>{ user.email }</th>
                    <th>{ user.status }</th>
                    <th>
                        <ul class="list-unstyled">
                            { processRoles(user) }
                        </ul>
                    </th>
                    <th>
                   
                        <button className="btn btn-sm btn-outline-secondary" onClick={ () => this.changeStatus(user, this.getAllUsers) }>Change Status</button>
                        <button className="btn btn-sm btn-outline-secondary ml-2" onClick={ () => this.changeRole(user, this.getAllUsers) }>Change Role</button>
                        
                    </th>
                </tr>
            )
        })

        return(
            <div className="container">
                <div className="row mb-2">
                    <div className="col">
                        <h4>Users</h4>
                        <Link className="btn btn-sm btn-outline-secondary mb-2" to="/signup">Add New User</Link>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">User</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Role</th>
                                    <th scope="col">Administration</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users}
                                
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default AdminUsers; 